const state = () => ({
    datarepair: {
        show: false,
        mobilePhone: "",
    },
    webshop: {
        show: false,
    },
});

const getters = {
    getDatarepairState(state) {
        return state.datarepair;
    },
    getWebshopState(state) {
        return state.webshop.show;
    },
};

const actions = {};

const mutations = {
    setDatarepairState(state, payload) {
        state.datarepair = payload;
    },
    setDatarepairStateShow(state, payload) {
        state.datarepair.show = payload;
    },
    setWebshopState(state, payload) {
        state.webshop.show = payload;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
